import sortByQuality from '@anm/helpers/sortByQuality';
import { useCallback, useEffect } from 'react';

import { Player, MediaObject } from '../../../types';

type UseDownloadSrcProps = {
  name?: string;
  player: Player | null;
  sources: MediaObject[];
};

const useDownloadSrc = ({ player, sources, name = 'video' }: UseDownloadSrcProps) => {
  const mediaQuery = `?filename=${name}.mp4`;

  const disableDownload = useCallback((e: Event) => e.preventDefault(), []);

  useEffect(() => {
    if (!player) return;

    const downloadButton = document.querySelector('[data-plyr="download"]');

    const bestQualityVideo = sortByQuality(sources)[0];

    if (!sources.length) {
      downloadButton?.addEventListener('click', disableDownload);
    } else {
      player.download = `${bestQualityVideo.path}${mediaQuery}`;
    }

    return () => downloadButton?.removeEventListener('click', disableDownload);
  }, [player, sources]);
};

export default useDownloadSrc;
